import { HTTPTYPE } from "@/utils/roi.request";

export const commonConfigs = {
    headers: {
        'Content-Type' : HTTPTYPE.JSON
    }
}

export const uploadConfings = {
    headers: {
        'Content-Type' : 'multipart/form-data'
    }
};